import { initBlogArticle } from "./util/blogArticle";
import { initCarousels } from "./util/carousel";
import {
  initConsentSubmitButtons,
  syncConsentSubmitButton,
  validateConsentNotices,
} from "./util/consentNotices";
import { expandProductSpecification } from "./util/expand-product-specification";
import { initBestSellingProducts } from "./util/getBestSellingProducts";
import { initMenuDrawerClose } from "./util/menuDrawerClose";
import { initRecentlyViewedProducts } from "./util/recentlyViewedProducts";
import { initPurchaseSticky } from "./util/purchaseSticky";
import { initSelectDropdowns } from "./util/selectDropdown";
import { initChannelTalk } from "./util/channelTalk";

window.validateConsentNotices = validateConsentNotices;
window.syncConsentSubmitButton = syncConsentSubmitButton;

document.addEventListener("DOMContentLoaded", () => {
  initBlogArticle();

  initRecentlyViewedProducts();

  initCarousels();

  expandProductSpecification();

  initConsentSubmitButtons();

  initSelectDropdowns();

  initBestSellingProducts();

  initMenuDrawerClose();

  initChannelTalk();

  initPurchaseSticky();
});
